<template>
	<v-card elevation="5" class="mt-3 text-left pa-3" :style="dialog ? 'margin-top:15px; !important' : ''">
		<div class="text-left">
			<div class="font-weight-bold">{{ $t('scoring') }}</div>
			<div class="font-weight-medium font-size13">
				{{ $t('mdq-description') }}
			</div>
			<ul class="font-weight-medium font-size13">
				<li>{{ $t('mdq-list-1') }}</li>
				<li>{{ $t('mdq-list-2') }}</li>
				<li>{{ $t('mdq-list-3') }}</li>
			</ul>
		</div>
	</v-card>
</template>

<script>
export default { name: 'MoodDisorderQuestionnaire', props: ['dialog'] };
</script>
